import { useServicesBillingDetails } from './useServicesBillingDetails.tsx';
export const useServiceBillingDetails = (param)=>{
    let { service, relationshipEffectiveDate, enabled = true } = param;
    const { servicesBillingDetails, isFetching } = useServicesBillingDetails({
        services: [
            service
        ],
        relationshipEffectiveDate,
        enabled
    });
    const serviceBillingDetails = servicesBillingDetails[service.id];
    return {
        periods: serviceBillingDetails === null || serviceBillingDetails === void 0 ? void 0 : serviceBillingDetails.periods,
        nextBillingDate: serviceBillingDetails === null || serviceBillingDetails === void 0 ? void 0 : serviceBillingDetails.nextBillingDate,
        isFetching
    };
};
